import type { ReactNode } from 'react';
import { cn } from 'v5/platform/dom/cn';

/** The title row of a unit: its name, muted, with whatever the host puts beside it. */
export function UnitTitle({
  groupTitle,
  children
}: {
  /** Its fields show labels of their own: the title stands out from them. */
  groupTitle: boolean;
  children: ReactNode;
}) {
  return (
    <h3
      className={cn(
        'flex flex-wrap items-center gap-x-2 gap-y-1 text-base text-fg-muted',
        // A group's title stands out from its fields' labels.
        groupTitle ? 'font-semibold' : 'font-normal'
      )}
    >
      {children}
    </h3>
  );
}

/**
 * Before a unit's title: what kind of value the unit holds. Its slot is as
 * wide as a row's lead (`RowListLeadIcon`): with the title's gap it makes the
 * gutter the unit's content is indented by, where rows hang their leads.
 */
export function UnitTitleIcon({ children }: { children: ReactNode }) {
  return (
    <span
      aria-hidden
      className="flex size-5 shrink-0 items-center justify-center [&>svg]:size-4"
    >
      {children}
    </span>
  );
}
